import moment from 'moment';
import { openPrintWindow, escapeHtml } from '../MedicineOrders/printDispenseAuthorization';
import { buildMinistryPrintHtml } from '../../Shared/printLayout';

function fmtDate(v) {
    if (!v) return '—';
    try { return moment(v).format('YYYY/MM/DD HH:mm'); } catch { return '—'; }
}

export function buildExternalPurchaseRequestHtml(detail) {
    const lines = (detail.lines || []).map((line, index) => `
        <tr class="${index % 2 === 0 ? 'bg-gray-striped-1' : 'bg-gray-striped-2'}"><td>${index + 1}</td><td>${escapeHtml(line.productName || '')}</td><td>${line.isOnNationalFormulary ? 'نعم' : 'لا'}</td><td>${Number(line.quantity || 0)}</td><td>${escapeHtml(line.lineNote || '—')}</td></tr>
    `).join('');
    const approvals = (detail.approvals || []).map((row, index) => `
        <tr class="${index % 2 === 0 ? 'bg-gray-striped-1' : 'bg-gray-striped-2'}"><td>${index + 1}</td><td>${Number(row.stepNo || index + 1)}</td><td>${escapeHtml(row.requiredRoleLabel || row.requiredRole || '—')}</td><td>${escapeHtml(row.decisionLabel || '—')}</td><td>${escapeHtml(row.note || '—')}</td></tr>
    `).join('');

    const infoHtml = `
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>المرفق</th><td>${escapeHtml(detail.branchName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>المورد</th><td>${escapeHtml(detail.supplierName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>الحالة</th><td>${escapeHtml(detail.statusLabel || '—')}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>الالتزام بالقائمة</th><td>${detail.enforceFormularyOnly ? 'نعم' : 'لا'}</td></tr>
              <tr class="bg-gray-striped-2"><th>الملاحظة</th><td>${escapeHtml(detail.note || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>أنشئ</th><td>${escapeHtml(fmtDate(detail.createdOn))} - ${escapeHtml(detail.createdByName || '—')}</td></tr>
            </tbody>
          </table>
        </div>`;

    const bodyHtml = `
      <table class="table table-sm table-bordered text-center border border-dark align-middle mt-1">
        <thead>
          <tr class="bg-gray"><th>#</th><th>الصنف</th><th>ضمن القائمة</th><th>الكمية</th><th>ملاحظة</th></tr>
        </thead>
        <tbody>${lines || '<tr><td colspan="5" class="text-center">لا توجد بنود</td></tr>'}</tbody>
      </table>
      <div class="section-title">مسار الاعتماد</div>
      <table class="table table-sm table-bordered text-center align-middle">
        <thead>
          <tr class="bg-gray"><th>#</th><th>الخطوة</th><th>الدور</th><th>القرار</th><th>الملاحظة</th></tr>
        </thead>
        <tbody>${approvals || '<tr><td colspan="5" class="text-center">لا توجد بيانات اعتماد</td></tr>'}</tbody>
      </table>`;

    const signaturesHtml = `
        <div class="col-4"><p><strong>إعداد الطلب</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>اعتماد الجهة المختصة</strong><br/>الاسم: ............................<br/>التوقيع والختم: ............................</p></div>
        <div class="col-4"><p><strong>الختم الرسمي</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>`;

    return buildMinistryPrintHtml({
        title: 'طلب توريد',
        docRef: detail.code || detail.id || detail.branchName || '',
        infoHtml,
        bodyHtml,
        signaturesHtml,
        footerSummary: 'وثيقة طلب توريد تُستخدم لاعتماد الأصناف المطلوبة من الجهات الخارجية ومتابعة مسار الموافقة قبل التنفيذ.',
        footerMeta: `مرجع الطلب: <strong>${escapeHtml(detail.code || String(detail.id || ''))}</strong>`
    });
}

export function printExternalPurchaseRequest(detail) {
    return openPrintWindow(buildExternalPurchaseRequestHtml(detail));
}
